export const serviceAreas = [
  { en: 'Chicago & surrounding areas', es: 'Chicago y alrededores' },
  { en: 'Chicagoland suburbs', es: 'Suburbios de Chicagoland' },
  { en: 'Cook County', es: 'Condado de Cook' },
  { en: 'DuPage County', es: 'Condado de DuPage' },
  { en: 'Will County', es: 'Condado de Will' },
  { en: 'Other surrounding regions', es: 'Otras regiones circundantes' },
];
